var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgHelpicon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 52,
    height: 52,
    viewBox: "0 0 52 52",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_5_16504)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 8,
    y: 6,
    width: 36,
    height: 36,
    rx: 18,
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.9373 20.3896C29.7186 19.9114 29.4076 19.4817 29.0108 19.1146C28.2045 18.3661 27.1342 17.9536 25.9998 17.9536C24.8654 17.9536 23.7951 18.3661 22.9889 19.113C22.592 19.4817 22.2811 19.9099 22.0623 20.3896C21.8342 20.8896 21.7186 21.4192 21.7186 21.9661V22.388C21.7186 22.4849 21.7967 22.563 21.8936 22.563H22.7373C22.8342 22.563 22.9123 22.4849 22.9123 22.388V21.9661C22.9123 20.4114 24.2967 19.1474 25.9998 19.1474C27.7029 19.1474 29.0873 20.4114 29.0873 21.9661C29.0873 22.6036 28.8608 23.2036 28.4311 23.7036C28.0061 24.1989 27.4061 24.5536 26.742 24.7036C26.3623 24.7896 26.0201 25.0036 25.7779 25.3099C25.5366 25.6151 25.4051 25.9926 25.4045 26.3817V26.8724C25.4045 26.9692 25.4826 27.0474 25.5795 27.0474H26.4233C26.5201 27.0474 26.5983 26.9692 26.5983 26.8724V26.3817C26.5983 26.1364 26.7686 25.9208 27.0045 25.8677C27.917 25.6614 28.7451 25.1692 29.3373 24.4817C29.6358 24.1333 29.8686 23.7458 30.0295 23.3255C30.1967 22.8896 30.2811 22.4317 30.2811 21.9661C30.2811 21.4192 30.1654 20.888 29.9373 20.3896ZM25.9998 28.2974C25.517 28.2974 25.1248 28.6896 25.1248 29.1724C25.1248 29.6552 25.517 30.0474 25.9998 30.0474C26.4826 30.0474 26.8748 29.6552 26.8748 29.1724C26.8748 28.6896 26.4826 28.2974 25.9998 28.2974Z",
    fill: "black",
    fillOpacity: 0.85
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_5_16504",
    x: 0,
    y: 0,
    width: 52,
    height: 52,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 4
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.15 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_5_16504"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_5_16504",
    result: "shape"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHelpicon);
export default __webpack_public_path__ + "static/media/Helpicon.07eb9cc10134315be297c8dabc0b127a.svg";
export { ForwardRef as ReactComponent };